import { render, staticRenderFns } from "./deleteAccountDoneModal.vue?vue&type=template&id=8e8d15c4&"
import script from "./deleteAccountDoneModal.vue?vue&type=script&lang=ts&"
export * from "./deleteAccountDoneModal.vue?vue&type=script&lang=ts&"
import style0 from "./deleteAccountDoneModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports